import * as moment from 'moment-timezone';


export enum PendingTranslationStatus {
  none = 0,
  inProgress = 1,
  done = 2
}

export interface PendingTranslation
{
    sourcePostId: string;
    draftId: string;
    feedName: string;
    feedId: string;
    sourceTitle: string;
    isHighlighted: boolean;
    sourceWordCount: number;
    publicationDateUtc: moment.Moment;
    automaticTitleTranslation?: string;
    automaticContentTranslation?: string;
    translationSchedulingDateUtc?: moment.Moment;
    pendingTranslationStatus: PendingTranslationStatus;
}



// WEBPACK FOOTER //
// ./src/app/postTranslations/model/PendingTranslation.ts